<template>
    <div class="section" key="redlightAccusationTime">
        <div class="section-title">
            <div class="author"><img width="50" height="50" src="@/assets/images/rabier.png"></div>
            <h3>Wie lange war die Ampel schon rot?</h3>
            <p>Bitte prüfen Sie den Bescheid: Sind Sie innerhalb oder außerhalb geschlossener Ortschaften geblitzt worden?</p>
        </div>
        <div class="form-container">
            <div class="form-card">
            <input type="radio" v-model="user.redlightAccusationTime" name="radio-3" value="<1s" id="question-11-1">
            <label for="question-11-1" v-on:click="incrementChecked()"><span class="label-icon"><img src="@/assets/images/icons8-time.svg"></span><span>unter 1 Sekunde</span></label>
            </div>
            <div class="form-card">
            <input type="radio" v-model="user.redlightAccusationTime" name="radio-3" value=">1s" id="question-11-2">
            <label for="question-11-2" v-on:click="incrementChecked()"><span class="label-icon"><img src="@/assets/images/icons8-time.svg"></span><span>1 Sekunde oder länger</span></label>
            </div>
            <div class="form-card">
            <input type="radio" v-model="user.redlightAccusationTime" name="radio-3" value="unsicher" id="question-11-3">
            <label for="question-11-3" v-on:click="incrementChecked()"><span class="label-icon"><img src="@/assets/images/icons8-ask-question.svg"></span><span>Weiß nicht genau</span></label>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'RedlightAccusationTime',
  computed: mapState({
    user: (state) => state.user,
    checked: (state) => state.checked
  }),
  methods: {
    ...mapMutations([
      'incrementChecked'
    ]),
  }
}
</script>